import React from 'react';
import DummyImageUploader from '../../../../../../../../PlusWebsiteEditor/components/ImageUploader/DummyImageUploader';
import { uploadImage } from '../../../../../../../../PlusWebsiteEditor/components/ImageUploader/ImageUploader.utils';
import { resizeImageTo1080p } from '../utils';

type Props = {
  title: string;
  url: string | null;
  onChange: (resizedImage: File) => void;
  className?: string;
  helperText?: string | null;
  accept?: string;
  onRemove?: () => void;
};

const BlobImageUploader = ({ title, url, className, helperText, accept, onRemove, onChange }: Props) => {
  const handleClick = async () => {
    const image = await uploadImage(accept);

    const resizedImage = await resizeImageTo1080p(image);

    if (resizedImage) {
      onChange(resizedImage);
    }
  };

  return (
    <DummyImageUploader
      className={className}
      helperText={helperText}
      title={title}
      url={url}
      onChangeClick={handleClick}
      onRemove={onRemove}
    />
  );
};

export default BlobImageUploader;
